import { call, put } from "redux-saga/effects";
import {
  getListSuccess,
  getListError,
  loadMoreSuccess,
  loadMoreError,
} from "../../slices/vehicleSlice";
import { vehicleGetData } from "../../../apis/vehicle";

export function* handleGetList(action) {
  try {
    const {
      authToken,
      location_id,
      limit,
      skip,
      search,
      vehicleNumber,
      isSearchEnable,
      isFilterByPrep,
      nonce,
      page,
    } = action.payload;

    const responseData = yield call(vehicleGetData, {
      ...action.payload,
      // authToken,
      // location_id,
      // vehicleNumber,
      // isSearchEnable,
      // isFilterByPrep,
      // nonce,
      // limit,
      // skip,
      // search,
      // page,
    });

    if (responseData && responseData.status === 1) {
      yield put(getListSuccess({ ...responseData }));
    } else {
      yield put(getListError({ ...responseData }));
    }
  } catch (error) {
    yield put(getListError({ message: "Something went wrong." }));

    console.log(error);
  }
}

// export function* handleLoadMore(action) {
//   try {
//     const {
//       authToken,
//       location_id,
//       search,
//       vehicleNumber,
//       isSearchEnable,
//       isFilterByPrep,
//       nonce,
//       page,
//       ...props
//     } = action.payload;
//     const responseData = yield call(vehicleGetData, {
//       authToken,
//       location_id,
//       vehicleNumber,
//       isSearchEnable,
//       isFilterByPrep,
//       nonce,
//       page: page + 1,
//       search,
//       ...props,
//     });

//     if (responseData && responseData.status === 1) {
//       yield put(loadMoreSuccess({ ...responseData }));
//     } else {
//       yield put(loadMoreError({ ...responseData }));
//     }
//   } catch (error) {
//     yield put(getListError({ message: "Something went wrong." }));

//     console.log(error);
//   }
// }

export function* handleLoadMore(action) {
  try {
    const {
      authToken,
      location_id,
      search,
      limit,
      station,
      vehicleNumber,
      isSearchEnable,
      isFilterByPrep,
      nonce,
      page,
      vehicle_sort,
      sort_up,
    } = action.payload;
    console.log("SSSSS vehicleGetData called from handleLoadMore ");
    const responseData = yield call(vehicleGetData, {
      // authToken,
      // location_id,
      // vehicleNumber,
      // isSearchEnable,
      // isFilterByPrep,
      // nonce,
      // sort_up,
      // limit,
      // vehicle_sort,
      // page: page,
      // search,
      // station
      ...action.payload,
    });
    if (responseData && responseData.status === 1) {
      yield put(loadMoreSuccess({ ...responseData }));
    } else {
      yield put(loadMoreError({ ...responseData }));
    }
  } catch (error) {
    yield put(getListError({ message: "Something went wrong." }));

    console.log(error);
  }
}
